import { useHover } from '@react-aria/interactions';
import {
  InteractableComponent,
  Text,
  TextProps,
  Tooltip,
} from '@shared/components';
import { makeElementClassNameFactory, makeRootClassName } from '@shared/utils';
import clsx from 'clsx';
import { ForwardedRef, ReactElement, forwardRef, useState } from 'react';

export type CopyableTextProps = TextProps;

const ROOT = makeRootClassName('CopyableText');
const el = makeElementClassNameFactory(ROOT);

const DEFAULT_PROPS = {} as const;

function CopyableText(
  props: CopyableTextProps,
  _ref: ForwardedRef<HTMLDivElement>
): ReactElement {
  const p = { ...DEFAULT_PROPS, ...props };
  const { hoverProps, isHovered } = useHover({ isDisabled: false });

  const [recentlyPressed, setRecentlyPressed] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(p.children as string);
    setRecentlyPressed(true);
    setTimeout(() => {
      setRecentlyPressed(false);
    }, 1000);
  };

  return (
    <InteractableComponent
      onPress={handleCopy}
      {...hoverProps}
      className={clsx(
        ROOT,
        {
          'is-hovered': isHovered,
        },
        p.className
      )}
    >
      <Tooltip
        content="Click to copy"
        isInstant
        side="bottom"
        className={el`tooltip`}
      >
        <div>
          {recentlyPressed ? <Text {...p}>Copied!</Text> : <Text {...p} />}
        </div>
      </Tooltip>
    </InteractableComponent>
  );
}

export const CopyableTextForwardRef = forwardRef<
  HTMLDivElement,
  CopyableTextProps
>(CopyableText);

export default CopyableTextForwardRef;
